import { type RefCallback, useLayoutEffect, useState } from 'react';

import { Size } from '../types/dom';
import { addResizeListener } from '../utils/dom';

export type UseElementSize = {
  ref: RefCallback<HTMLElement>;
  size: Size;
};

export const useElementSize = (): UseElementSize => {
  const [size, setSize] = useState<Size>({ width: 0, height: 0 });
  const [element, setElement] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const setElementSize = () => {
      if (!element) {
        return;
      }

      const { width, height } = element.getBoundingClientRect();

      setSize((currentSize) =>
        currentSize.width === width && currentSize.height === height ? currentSize : { width, height }
      );
    };

    setElementSize();

    if (!element) {
      return;
    }

    return addResizeListener(element, setElementSize);
  }, [element]);

  return {
    ref: setElement,
    size,
  };
};
